import { AdminLayout } from "../components/AdminLayout";
// import { UsersAdmin, DashboardAdmin } from "../pages/Admin";

import Destinospage from "../pages/Destinospage";
import Estadospage from "../pages/Estadospage";
import Notespage from "../pages/Notespage";

//import "./DashboardAdmin.scss";

function DashboardAdmin() {
  return (
    <div className="dashboard-admin">
      <h1>DashboardAdmin</h1>
    </div>
  );
}

const routesAdmin = [
  {
    path: "/notes",
    layout: AdminLayout,
    component: Notespage,
  },
  {
    path: "/destinos",
    layout: AdminLayout,
    component: Destinospage,
  },
  {
    path: "/estados",
    layout: AdminLayout,
    component: Estadospage,
  },  
];
export default routesAdmin;
